/* global dataLayer */

/**
 * Remove a voorstelling from the dataLayer,
 * and send an event with all its details
 */
function deleteFrom(set, box_office_id) {
    set.forEach(cart_entry => {
        const index = set.indexOf(cart_entry);
        if (cart_entry.item_id === box_office_id) {
            const blob = set[index];
            set.splice(index, 1);

            return blob;
        }
    });
}

export function datalayerDelete(box_office_id) {
    // live update the datalayer
    // the first object in it is our modern datablob

    deleteFrom(dataLayer[0].ga4_ecommerce_items, box_office_id);

    // send an event container a standard GA layout + additional payload
    dataLayer.push({
        'event': 'cart_remove',
        'eventCategory': 'product',
        'eventAction': 'remove_from_cart',
        'eventLabel': box_office_id,
        'eventPayload': deleteFrom(dataLayer[0].order_items, box_office_id)
    });
}
